import React from 'react';
import {
  MULTI_FACTOR_AUTHENTICATION,
  RESIDEO_ACADEMY_SPLASH_PAGE,
  DATA_ERASURE,
  CENTRAL_STATION_BUSINESS_TYPE,
  SIGNUP_RECAPTCHA,
  RESIDEO_TECH_APP,
} from 'config/flags';

export interface IFeatureFlagsContext {
  MULTI_FACTOR_AUTHENTICATION: boolean;
  RESIDEO_ACADEMY_SPLASH_PAGE: boolean;
  DATA_ERASURE: boolean;
  CENTRAL_STATION_BUSINESS_TYPE: boolean;
  SIGNUP_RECAPTCHA: boolean;
  RESIDEO_TECH_APP: boolean;
}

const defaultFlags: IFeatureFlagsContext = {
  MULTI_FACTOR_AUTHENTICATION,
  RESIDEO_ACADEMY_SPLASH_PAGE,
  DATA_ERASURE,
  CENTRAL_STATION_BUSINESS_TYPE,
  SIGNUP_RECAPTCHA,
  RESIDEO_TECH_APP,
};

const FeatureFlagsContext =
  React.createContext<IFeatureFlagsContext>(defaultFlags);

export const FeatureFlagsProvider = ({ children }) => {
  return (
    <FeatureFlagsContext.Provider value={defaultFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => React.useContext(FeatureFlagsContext);
